import React, { useMemo } from "react"
import { useRewardsProgramData, useUser } from "@/queries/user"
import { WidgetWrapper } from "./WidgetWrapper"
import { router } from "expo-router"
import * as HomeEvents from "@/analytics/events/home"
import WidgetCommonContainer, {
  WidgetCommonFTUContainer,
} from "@/components/widgets/WidgetCommonContainer"
import BottomIcon from "@/assets/clipart/widgets/rewards-bottom-icon.svg"
import {
  complicatedNumberFormating,
  numberWithCommas,
} from "@/utils/NumberUtils"
import { View } from "react-native"
import ProgressBar from "@/components/widgets/ProgressBar"
import { Small, SmallBold } from "@/components/standard/BFText"

export default function RewardsWidget() {
  const { data: user } = useUser()
  const { data: rewardsProgramData } = useRewardsProgramData()
  const balance = user?.me?.lastPointTransaction?.balance ?? 0
  const hasRewards: boolean = balance > 0 || false
  // To test....
  // const hasRewards: boolean = false

  const nextTier = rewardsProgramData?.tiers?.find(
    (tier) => (tier?.minPointsRequired || 0) >= balance
  )

  const ctaContent = useMemo(() => {
    if (balance === 0 || !nextTier) {
      return null
    }

    if (nextTier.name === "diamond" || balance === nextTier.minPointsRequired) {
      return (
        <Small className={"text-white mt-2"}>
          <SmallBold>{nextTier.label}</SmallBold> discounts unlocked!
        </Small>
      )
    }

    return (
      <Small className={"text-white mt-2"}>
        Earn {numberWithCommas(nextTier.minPointsRequired)} pts to unlock{" "}
        <SmallBold>{nextTier.label}</SmallBold> discounts
      </Small>
    )
  }, [nextTier, balance])

  const progress = nextTier
    ? (balance / (nextTier.minPointsRequired || 1)) * 100
    : 0

  const onPress = () => {
    HomeEvents.homepageWidgetClicked({
      nextScreen: "Rewards",
      widgetType: "widget-rewards",
      widgetTitle: "Rewards",
      widgetState: hasRewards ? "non-zero-value" : "zero-value",
      widgetValue: hasRewards ? balance.toString() : undefined,
      widgetCta:
        balance === 0
          ? "More closes, more cash"
          : nextTier?.label || "Loading...",
    })
    router.push("/rewards/")
  }

  return (
    <WidgetWrapper
      title="Rewards"
      category="rewards"
      orientation="vertical"
      onPress={onPress}
    >
      {!hasRewards ? (
        <WidgetCommonFTUContainer
          headerText={"Flip more, save more"}
          subTitle={"5k points when you close your 1st deal"}
          BottomIconComponent={BottomIcon}
        />
      ) : (
        <WidgetCommonContainer
          headerCount={complicatedNumberFormating(balance)}
          subTitle={"Points"}
        >
          <View className={"self-stretch my-2"}>
            <ProgressBar progress={progress} />
            {ctaContent}
          </View>
        </WidgetCommonContainer>
      )}
    </WidgetWrapper>
  )
}
